export default __webpack_public_path__ + "static/media/ButtonBravo.9c6f47ce.png";